<template>
    <div ref="dropdownComponent" class="dropdown-component">
        <slot name="trigger">
            <el-button
                class="trigger-button"
                circle
                icon="ti-more-alt"
                :class="{'dark-theme': dark}"
                @click="toggleDropdown"
            ></el-button>
        </slot>
        <div :class="{visible: visible, 'dark-theme': dark}" class="dropdown-container">
            <div
                v-for="(item, index) in items"
                :key="index"
                class="dropdown-item"
                @click="item.selection && item.selection.length ? toggleSelector() : item.callback()"
            >
                <div >
                    <i :class="item.iconClass"></i>{{ item.name }}
                    <div v-if="item.selection && item.selection.length" :class="{visible: showSelector}" class="selector">
                        <el-checkbox
                            v-for="(selectItem, index) in item.selection"
                            :key="index"
                            v-model="selectItem.selected"
                            @click="triggerDisplayChange"
                            class="selection-item"
                        >{{ selectItem.name }}</el-checkbox>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {
        // an item should have those keys:
        //  - name,
        //  - iconClass,
        //  - callback if the item is not a selector
        //  - selection if the item is a selector
        //      selection is an array of Object with self explanatory keys :
        //          - name
        //          - selected (Boolean initialized at false)
        items: {
            type: Array,
            required: true
        },
        dark: {
            type: Boolean,
            required: true
        }
    },

    data: function(){
        return {
            visible: false,
            showSelector: false,
            eventListenerId: '',
        };
    },

    computed: {
        hasFilledSelector() {
            return this.items.find(item => item.selection && item.selection.length);
        },
        selection() {
            if (this.hasFilledSelector !== undefined) {
                return this.items.find(item => item.selection && item.selection.length).selection.filter(item => item.selected === true);
            } else {
                return [];
            }
        }
    },

    mounted() {
        if (this.eventListenerId === '') {
            this.eventListenerId = window.addEventListener('click', this.dropdownEventListener);
        }
    },
    destroyed() {
        if (this.eventListenerId !== '') {
            window.removeEventListener('click', this.dropdownEventListener);
        }
    },

    methods: {
        dropdownEventListener(event) {
            if (!this.$refs.dropdownComponent.contains(event.target)) {
                if (this.visible === true) {
                    this.visible = false;
                }
            }
        },
        toggleDropdown() {
            this.visible = !this.visible;
        },
        toggleSelector() {
            this.showSelector = !this.showSelector;
        },
        triggerDisplayChange() {
            this.$emit('triggerDisplayChange', this.selection);
        }
    },
};
</script>

<style lang="scss">
.dropdown-component {
    position: relative;
    color: #606266;
    .trigger-button {
        background: unset;
        border: unset;
        &:hover {
            background: unset;
            border: unset;
            color: #606266;
        }
        &.dark-theme {
            color: #C4C4C4;
            &:hover {
                color: #C4C4C4;
            }
        }
    }
    .dropdown-container {
        position: absolute;
        display: none;
        right: 0;
        width: 200px;
        z-index: 2;
        background-color: white;
        border-radius: 4px;
        border: 1px solid #ebeef5;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        margin: 12px 0;
        padding: 10px 0;
        &.visible {
            display: block;
        }
        .dropdown-item {
            position: relative;
            padding: 0 20px;
            display: flex;
            align-items: center;
            height: 35px;
            cursor: pointer;
            &:hover {
                background-color: #ecf5ff;
                color: #66b1ff;
            }
            i {
                margin-right: 5px;
            }
            .selector {
                display: none;
                position: absolute;
                right: 205px; // parent width + 5px for the spacing
                top: -10px;
                width: 200px;
                z-index: 2;
                background-color: white;
                border-radius: 4px;
                border: 1px solid #ebeef5;
                box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
                padding: 10px 0;
                &.visible {
                    display: block;
                }
                .selection-item {
                    padding: 0 20px;
                    width: 100%;
                    height: 35px;
                    margin: 0;
                    display: flex;
                    align-items: center;
                    &:hover {
                        background-color: #ecf5ff;
                        color: #66b1ff;
                    }
                }
            }
        }
        &.dark-theme {
            background-color: #444444;
            border-color: #444444;
            .dropdown-item {
                color: #EEEEEE !important;
            }
            .dropdown-item:hover {
                background-color: #222222 !important;
            }
            .popper__arrow {
                border-bottom-color: #444444 !important;
                &::after {
                    border-bottom-color: #444444 !important;
                }
            }

        }
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/partials/dropdownWithSelector/index.vue